import mutation from './mutation.graphql.js'
import mutation_update from './mutation-update.graphql.js'
import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, executeMutationCreate] = useMutation(mutation)
  let [, executeMutationUpdate] = useMutation(mutation_update)
  let [, notify] = useNotifications()

  let location_id = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'selected.comms_settings.location_id',
  })

  return async function onSubmit({ args, value }) {
    let executeMutation =
      value.id === null ? executeMutationCreate : executeMutationUpdate

    let mutationResponse = await executeMutation({
      location_id,
      id: value.id,
      sending_window: {
        from: value.from,
        to: value.to,
        allowed_days: value.allowed_days,
      },
      flags: value.flags,
      create: value.id !== null,
    })

    if (mutationResponse.error) {
      notify(notifyError('Something went wrong'))
    } else {
      notify(notifySuccess('Settings updated successfully'))
    }
  }
}
